/**
 * Labels for notification-type codes returned by the preferences API.
 * Backend has no fixed enum; LEAVE_STATUS is confirmed by backend tests.
 */
const LABELS: Record<string, string> = {
  LEAVE_STATUS: 'Leave',
  LEAVE: 'Leave',
  LEAVE_SUBMITTED: 'Leave',
  LEAVE_CANCELLED: 'Leave',
  LEAVE_REJECTED: 'Leave',
  ATTENDANCE: 'Attendance',
  CORRECTION_SUBMITTED: 'Attendance correction',
  CORRECTION_CANCELLED: 'Attendance correction',
  CORRECTION_REJECTED: 'Attendance correction',
  ATTENDANCE_CORRECTION: 'Attendance correction',
  WFH: 'Work from home',
  WFH_STATUS: 'Work from home',
  WFH_SUBMITTED: 'Work from home',
  WFH_CANCELLED: 'Work from home',
  WFH_REJECTED: 'Work from home',
  HOLIDAY_REMINDER: 'Holiday',
  HOLIDAY: 'Holiday',
  PERMISSION: 'Permission',
  PERMISSION_STATUS: 'Permission',
  WORKFLOW: 'Approval',
  SYSTEM: 'System',
  SECURITY: 'System',
};

const CATEGORIES: Record<string, string> = {
  LEAVE_STATUS: 'leave',
  LEAVE: 'leave',
  LEAVE_SUBMITTED: 'leave',
  LEAVE_CANCELLED: 'leave',
  LEAVE_REJECTED: 'leave',
  ATTENDANCE: 'attendance',
  CORRECTION_SUBMITTED: 'attendance',
  CORRECTION_CANCELLED: 'attendance',
  CORRECTION_REJECTED: 'attendance',
  ATTENDANCE_CORRECTION: 'attendance',
  WFH: 'wfh',
  WFH_STATUS: 'wfh',
  WFH_SUBMITTED: 'wfh',
  WFH_CANCELLED: 'wfh',
  WFH_REJECTED: 'wfh',
  HOLIDAY_REMINDER: 'holiday',
  HOLIDAY: 'holiday',
  PERMISSION: 'permission',
  PERMISSION_STATUS: 'permission',
  WORKFLOW: 'workflow',
  SYSTEM: 'system',
  SECURITY: 'system',
};

function normalize(code: string | null | undefined): string | null {
  if (!code || typeof code !== 'string') return null;
  const trimmed = code.trim().toUpperCase();
  return trimmed || null;
}

export function getNotificationTypeLabel(
  code: string | null | undefined,
): string {
  const key = normalize(code);
  if (!key) return 'Notification';
  return LABELS[key] ?? 'Notification';
}

export function getNotificationTypeMessage(
  code: string | null | undefined,
): string {
  const label = getNotificationTypeLabel(code);
  if (label === 'Notification') {
    return 'A notification is available.';
  }
  return `${label} notification.`;
}

export function getNotificationTypeCategory(
  code: string | null | undefined,
): string {
  const key = normalize(code);
  if (!key) return 'general';
  return CATEGORIES[key] ?? 'general';
}
